import { DragDropContext } from "react-dnd";
import createHTML5Backend from "react-dnd-html5-backend";

export default DragDropContext(createHTML5Backend);
